/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Cutoff_ThresholdInputs */



/**
* | output |
* | --- |
* | "Score to reach top 5:" |
*
* @param {Tournament_Cutoff_ThresholdInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_cutoff_threshold = /** @type {((inputs?: Tournament_Cutoff_ThresholdInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Cutoff_ThresholdInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Score pour atteindre le top 5 :")
	if (locale === "es") return /** @type {LocalizedString} */ ("Puntuación para alcanzar el top 5:")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pontuação para alcançar o top 5:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Punteggio per raggiungere il top 5:")
	return /** @type {LocalizedString} */ ("Score to reach top 5:")
});